import { render, staticRenderFns } from "./GridViewLabel.vue?vue&type=template&id=32be1d64&scoped=true&functional=true&"
import script from "./GridViewLabel.vue?vue&type=script&lang=js&"
export * from "./GridViewLabel.vue?vue&type=script&lang=js&"
import style0 from "./GridViewLabel.vue?vue&type=style&index=0&id=32be1d64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "32be1d64",
  null
  
)

export default component.exports